import React, { useState } from "react";
import { Table, Button, message } from "antd";
import moment from "moment";
import { platformApi } from "../../../../../api";
import WrappedQuotationModal from "../../../Quotations/QuotationsForm";
import VehicleName from "../../../../VehicleName";

const AssociatedQuotations = ({ dataSource }) => {
  const [openModal, setOpenModal] = useState(false);
  const [quotationData, setQuotationData] = useState({});

  const getQuotation = (id) => {
    platformApi
      .get(`/api/quotation/${id}`)
      .then((res) => {
        let { data } = res;
        if (data.code === 200 && data.response.code === 200) {
          setQuotationData(data.response.data);
          setOpenModal(true);
        } else {
          message.error("Unable to fetch quotation details", 2);
        }
      })
      .catch(() => {
        message.error("Error while fetching quotation", 2);
      });
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "date",
      render: (val) => moment(val).format("DD-MM-YYYY"),
    },
    {
      title: "Quotation ID",
      dataIndex: "quotationId",
      key: "quotationId",
    },
    {
      title: "Model Code",
      key: "modelCode",
      render: (record) =>
        record.vehicle?.[0]?.vehicleDetail?.modelCode || "N/A",
    },
    {
      title: "Model Name",
      key: "modelName",
      width: 260,
      render: (record) => (
        <VehicleName
          nameOnly
          value={record.vehicle?.[0]?.vehicleDetail}
          fallback="N/A"
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Button type="link" onClick={(e) => {
          e.stopPropagation(); // prevent row click firing as well
          getQuotation(record.id);
        }}>
          View Quotation
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey="id"
        pagination={false}
        onRow={(record) => ({
          onClick: () => getQuotation(record.id),
        })}
      />

      {openModal && (
        <WrappedQuotationModal
          open={openModal}
          close={() => setOpenModal(false)}
          data={quotationData}
          editable={false}
        />
      )}
    </div>
  );
};

export default AssociatedQuotations;